import { render, staticRenderFns } from "./WMenu.vue?vue&type=template&id=267fa16a&"
import script from "./WMenu.vue?vue&type=script&lang=ts&"
export * from "./WMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports